import smoothscroll from 'smoothscroll-polyfill';

import './views/components/organisms/academy-header';
import './views/components/organisms/archive-header';
import './views/components/organisms/puffs';
import './views/components/organisms/questions-and-answers';
import './views/components/organisms/teacher-led-course-loop';
import './views/templates/single-self-study-course';
import './real-100vw';
import './login';

smoothscroll.polyfill();
